{
  "PAGINATION_FOOTER": {
    "SHOWING": "Showing {startItem} - {endItem} of {totalItems} items",
    "CURRENT_PAGE_INFO": "{currentPage} of {totalPages} pages"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "Select an option...",
    "EMPTY_SEARCH_RESULTS": "No items found for the search term `{searchTerm}`",
    "EMPTY_STATE": "No s'han trobat resultats.",
    "SEARCH_PLACEHOLDER": "Search...",
    "MORE": "+{count} més"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "Search...",
    "EMPTY_STATE": "No s'han trobat resultats.",
    "SEARCHING": "S'està cercant..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "Cancel·la",
      "CONFIRM": "Confirma"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "Search country",
    "ERROR": "Phone number should be empty or in E.164 format",
    "DIAL_CODE_ERROR": "Selecciona un codi de marcatge de la llista"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "L'autor no està disponible"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "Breadcrumb"
  },
  "SWITCH": {
    "TOGGLE": "Toggle switch"
  },
  "LABEL": {
    "TAG_BUTTON": "tag"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "Aprèn més",
    "WATCH_VIDEO": "Watch video"
  },
  "DURATION_INPUT": {
    "MINUTES": "Minuts",
    "HOURS": "Hores",
    "DAYS": "Dies",
    "PLACEHOLDER": "Introdueix la durada"
  }
}
